import { h } from 'preact';

import { GlobalState } from '../states/global-state';
// Code-splitting is automated for `routes` directory

import Spinner from './spinner';
import Modal from './modal';
import IziToast from './izitoast';

import { getDeviceType } from '../utils';

import Network from './network';
import CustomRouter from './router';
import { getProfile } from '../controllers/UserApiControler';
import { useEffect } from 'preact/hooks';
import Store from '../stores/Store';
import { VerifySession } from './socket';

const App = () => {
  useEffect(() => {
    const deviceType = getDeviceType();

    GlobalState.deviceType.value = deviceType;

    if (deviceType == 'desktop') {
      GlobalState.device.value = deviceType;
    } else if (['android', 'ios'].includes(deviceType)) {
      GlobalState.device.value = 'mobile';
    }

    VerifySession();
  }, []);

  return (
    <div id="app">
      <Spinner />
      <Modal>Error</Modal>
      <Modal>Success</Modal>
      <IziToast />
      <Network />

      <main>
        <CustomRouter />
      </main>
    </div>
  );
};

export default App;
